<script>
export default {
  props: {
    path: {
      type: String,
      required: true
    }
  },

  computed: {
    rawSvg() {
      return require(`images/${this.path}.svg?raw`);
    }
  }
};
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <span v-html="rawSvg" />
  <!-- eslint-enable vue/no-v-html -->
</template>
